(function () {
  function initBabaCinematic() {
    var hero = document.querySelector('.baba-cinematic-hero');
    if (!hero || hero.dataset.babaInitialized === 'true') return;
    hero.dataset.babaInitialized = 'true';
    document.body.classList.add('baba-cinematic-home');
    
    function syncBabaNavHeight() { var nav = document.querySelector('.baba-diagonal-nav'); if (!nav) return; var h = Math.ceil(nav.getBoundingClientRect().height); if (h > 0) document.documentElement.style.setProperty('--baba-nav-h', h + 'px'); }
    syncBabaNavHeight();
    window.addEventListener('resize', syncBabaNavHeight, { passive: true });
    window.addEventListener('load', syncBabaNavHeight);
        if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncBabaNavHeight); }
            setTimeout(syncBabaNavHeight, 400);
                setTimeout(syncBabaNavHeight, 1200);
                    if (window.ResizeObserver) {
                          var navEl = document.querySelector('.baba-diagonal-nav');
                                if (navEl) { new ResizeObserver(syncBabaNavHeight).observe(navEl); }
                                    }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var media = hero.querySelector('.baba-hero__media video.baba-hero__video--desktop') || hero.querySelector('.baba-hero__media img');
    var desktopVideo = hero.querySelector('.baba-hero__video--desktop');
    var mobileVideo = hero.querySelector('.baba-hero__video--mobile');

    // If a dedicated mobile video exists, switch to it at the mobile breakpoint.
    // The videos remain muted/inline so mobile browsers can autoplay them.
    function syncHeroVideo() {
      if (!desktopVideo || !mobileVideo) return;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        desktopVideo.pause();
        mobileVideo.play().catch(function () {});
      } else {
        mobileVideo.pause();
        desktopVideo.play().catch(function () {});
      }
    }
    syncHeroVideo();
    window.addEventListener('resize', syncHeroVideo, { passive: true });
    var copy = hero.querySelector('.baba-hero__copy');
    var eyebrow = hero.querySelector('.baba-eyebrow');
    var heading = hero.querySelector('h1');
    var subline = hero.querySelector('.baba-hero__subline');
    var cats = hero.querySelectorAll('.baba-hero__category');
    var cta = hero.querySelector('.baba-hero__cta');
    var scroll = hero.querySelector('.baba-hero__scroll');

    gsap.set([eyebrow, heading, subline, cats, cta], { opacity: 0, y: 26 });
    gsap.timeline({ defaults: { ease: 'power3.out' } })
      .to(eyebrow, { opacity: 1, y: 0, duration: .65 })
      .to(heading, { opacity: 1, y: 0, duration: .85 }, '-=.35')
      .to(subline, { opacity: 1, y: 0, duration: .6 }, '-=.45')
      .to(cats, { opacity: 1, y: 0, duration: .45, stagger: .06 }, '-=.3')
      .to(cta, { opacity: 1, y: 0, duration: .55 }, '-=.2');

    gsap.to(media, {
      scale: 1.13,
      yPercent: 6,
      ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
    gsap.to(copy, {
      yPercent: -9,
      ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
    gsap.to(scroll, {
      opacity: 0,
      y: 30,
      ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: '35% top', scrub: true }
    });

    document.querySelectorAll('.baba-diagonal-card').forEach(function (card, i) {
      gsap.from(card, {
        opacity: 0,
        y: 50,
        duration: .8,
        delay: i * .04,
        ease: 'power3.out',
        scrollTrigger: { trigger: card, start: 'top 90%', toggleActions: 'play none none reverse' }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBabaCinematic);
  } else {
    initBabaCinematic();
  }
  document.addEventListener('shopify:section:load', initBabaCinematic);
})();
